import {
	IGReportRes,
	NBReportRes,
	TTReportRes,
	TWReportRes,
	YTReportRes,
} from '@apis/orval/model';

import round from '@utils/round';

import { ReportProfileProps } from '../report-profile/ReportProfile';
import { PlatformCode } from 'src/type/common';

export class ProfileIgAdapter {
	private readonly value: IGReportRes;

	constructor(obj: IGReportRes) {
		this.value = obj;
	}

	get categories() {
		// const category1 = instagramCategories.get(this.value?.account?.category_1)?.();
		// const category2 = instagramCategories.get(this.value?.account?.category_2)?.();
		const category1 = this.value?.account?.category_1;
		const category2 = this.value?.account?.category_2;
		return [category1, category2].filter((v) => v) as string[];
	}

	get igRawData(): Record<string, string | undefined> {
		const posts = this.value?.account?.profile?.post_count;
		const followers = this.value?.account?.profile?.follower;
		const followings = this.value?.account?.profile?.following;
		return {
			게시물: posts ? round(posts, 'down') ?? '-' : '-',
			팔로워: followers ? round(followers, 'down') ?? '-' : '-',
			팔로잉: followings ? round(followings, 'down') ?? '-' : '-',
		};
	}

	adapt():
		| { isCompleted?: boolean; isCached?: boolean; props: ReportProfileProps }
		| undefined {
		if (!this.value?.account) return undefined;
		return {
			isCompleted: this.value?.is_completed ?? undefined,
			isCached: this.value?.is_cached_response ?? undefined,
			props: {
				profileImg: this.value?.account?.profile?.profile_img_link ?? undefined,
				platformCode:
					(this.value?.account?.profile?.platform_code as PlatformCode) ?? undefined,
				categories: this.categories,
				pk: this.value?.account?.profile?.platform_pk ?? undefined,
				username: this.value?.account?.profile?.username ?? undefined,
				isVerified: this.value?.account?.is_meta_verified ?? false,
				fullName: this.value?.account?.profile?.full_name ?? undefined,
				outLink: this.value?.account?.profile?.account_link ?? undefined,
				bio: this.value?.account?.profile?.description ?? undefined,
				rawData: this.igRawData,
			},
		};
	}
}
export class ProfileYtAdapter {
	private readonly value: YTReportRes;

	constructor(obj: YTReportRes) {
		this.value = obj;
	}

	get categories() {
		// const category1 = youtubeCategories.get(this.value?.account?.category_1)?.();
		// const category2 = youtubeCategories.get(this.value?.account?.category_2)?.();
		const category1 = this.value?.account?.category_1;
		const category2 = this.value?.account?.category_2;
		return [category1, category2].filter((v) => v) as string[];
	}

	get ytRawData() {
		const posts = this.value?.account?.profile?.post_count;
		const subscriber = this.value?.account?.profile?.follower;
		// const shortsRate = this.value?.account?.profile?.shorts_rate;
		return {
			동영상: posts ? round(posts, 'down') : '-',
			'구독자 수': subscriber ? round(subscriber, 'down') : '-',
		};
	}

	adapt():
		| { isCompleted?: boolean; isCached?: boolean; props: ReportProfileProps }
		| undefined {
		if (!this.value?.account) return undefined;
		return {
			isCompleted: this.value?.is_completed ?? undefined,
			isCached: this.value?.is_cached_response ?? undefined,
			props: {
				profileImg: this.value?.account?.profile?.profile_img_link ?? undefined,
				platformCode:
					(this.value?.account?.profile?.platform_code as PlatformCode) ?? undefined,
				categories: this.categories,
				pk: this.value?.account?.profile?.platform_pk ?? undefined,
				username: this.value?.account?.profile?.username ?? undefined,
				// isVerified: this.value?.account?.profile.
				fullName: this.value?.account?.profile?.full_name ?? undefined,
				outLink: this.value?.account?.profile?.account_link ?? undefined,
				bio: this.value?.account?.profile?.description ?? undefined,
				rawData: this.ytRawData,
			},
		};
	}
}
export class ProfileTtAdapter {
	private readonly value: TTReportRes;

	constructor(obj: TTReportRes) {
		this.value = obj;
	}

	get categories() {
		// const category1 = tiktokCategories.get(this.value?.account?.category_1)?.();
		// const category2 = tiktokCategories.get(this.value?.account?.category_2)?.();
		const category1 = this.value?.account?.category_1;
		const category2 = this.value?.account?.category_2;
		return [category1, category2].filter((v) => v) as string[];
	}

	get ttRawData() {
		const posts = this.value?.account?.profile?.post_count;
		const followers = this.value?.account?.profile?.follower;
		const followings = this.value?.account?.profile?.following;
		return {
			게시물: posts ? round(posts, 'down') : '-',
			팔로워: followers ? round(followers, 'down') : '-',
			팔로잉: followings ? round(followings, 'down') : '-',
		};
	}

	adapt():
		| { isCompleted?: boolean; isCached?: boolean; props: ReportProfileProps }
		| undefined {
		if (!this.value?.account) return undefined;
		return {
			isCompleted: this.value?.is_completed ?? undefined,
			isCached: this.value?.is_cached_response ?? undefined,
			props: {
				profileImg: this.value?.account?.profile?.profile_img_link ?? undefined,
				platformCode:
					(this.value?.account?.profile?.platform_code as PlatformCode) ?? undefined,
				categories: this.categories,
				pk: this.value?.account?.profile?.platform_pk ?? undefined,
				username: this.value?.account?.profile?.username ?? undefined,
				isTtcm: this.value?.account?.is_ttcm ?? undefined,
				fullName: this.value?.account?.profile?.full_name ?? undefined,
				outLink: this.value?.account?.profile?.account_link ?? undefined,
				bio: this.value?.account?.profile?.description ?? undefined,
				rawData: this.ttRawData,
			},
		};
	}
}
export class ProfileNbAdapter {
	private readonly value: NBReportRes;

	constructor(obj: NBReportRes) {
		this.value = obj;
	}

	get categories() {
		// const category1 = naverCategories.get(this.value?.account?.category_1)?.();
		// const category2 = naverCategories.get(this.value?.account?.category_2)?.();
		const category1 = this.value?.account?.category_1;
		const category2 = this.value?.account?.category_2;
		return [category1, category2].filter((v) => v) as string[];
	}

	get nbRawData() {
		const posts = this.value?.account?.profile?.post_count;
		const followers = this.value?.account?.profile?.follower;
		const bestBlogger = this.value?.account?.profile?.this_month_blog_count;
		return {
			게시물: posts ? round(posts, 'down') : '-',
			이웃: followers ? round(followers, 'down') : '-',
			'이달의 블로거 선정':
				bestBlogger !== null && bestBlogger !== undefined
					? round(bestBlogger, 'down')
					: '-',
		};
	}

	adapt():
		| { isCompleted?: boolean; isCached?: boolean; props: ReportProfileProps }
		| undefined {
		if (!this.value?.account) return undefined;
		return {
			isCompleted: this.value?.is_completed ?? undefined,
			isCached: this.value?.is_cached_response ?? undefined,
			props: {
				profileImg: this.value?.account?.profile?.profile_img_link ?? undefined,
				platformCode:
					(this.value?.account?.profile?.platform_code as PlatformCode) ?? undefined,
				categories: this.categories,
				pk: this.value?.account?.profile?.platform_pk ?? undefined,
				username: this.value?.account?.profile?.username ?? undefined,
				fullName: this.value?.account?.profile?.full_name ?? undefined,
				outLink: this.value?.account?.profile?.account_link ?? undefined,
				bio: this.value?.account?.profile?.description ?? undefined,
				rawData: this.nbRawData,
			},
		};
	}
}
export class ProfileTwAdapter {
	private readonly value: TWReportRes;

	constructor(obj: TWReportRes) {
		this.value = obj;
	}

	get categories() {
		// const category1 = twitterCategories.get(this.value?.account?.category_1)?.();
		// const category2 = twitterCategories.get(this.value?.account?.category_2)?.();
		const category1 = this.value?.account?.category_1;
		const category2 = this.value?.account?.category_2;
		return [category1, category2].filter((v) => v) as string[];
	}

	get twRawData() {
		const posts = this.value?.account?.profile?.post_count;
		const followers = this.value?.account?.profile?.follower;
		const following = this.value?.account?.profile?.following;
		return {
			게시물: posts !== null && posts !== undefined ? round(posts, 'down') : '-',

			팔로워:
				followers !== null && followers !== undefined ? round(followers, 'down') : '-',
			팔로잉:
				following !== null && following !== undefined ? round(following, 'down') : '-',
		};
	}

	adapt():
		| { isCompleted?: boolean; isCached?: boolean; props: ReportProfileProps }
		| undefined {
		if (!this.value?.account) return undefined;
		return {
			isCompleted: this.value?.is_completed ?? undefined,
			isCached: this.value?.is_cached_response ?? undefined,
			props: {
				profileImg: this.value?.account?.profile?.profile_img_link ?? undefined,
				platformCode:
					(this.value?.account?.profile?.platform_code as PlatformCode) ?? undefined,
				categories: this.categories,
				pk: this.value?.account?.profile?.platform_pk ?? undefined,
				username: this.value?.account?.profile?.username ?? undefined,
				fullName: this.value?.account?.profile?.full_name ?? undefined,
				isVerified: this.value?.account?.is_x_verified ?? undefined,
				outLink: this.value?.account?.profile?.account_link ?? undefined,
				bio: this.value?.account?.profile?.description ?? undefined,
				rawData: this.twRawData,
			},
		};
	}
}
